import * as Cesium from 'cesium';
import { elevationService, metersToSampleCount, DEFAULT_PROFILE_SAMPLING_LAYERS, } from '../../services/elevationService';
export const fetchLineElevationProfile = async (projectId, startPos, endPos, 
// The analytical layers to sample. Defaults to all of them; callers pass the
// ready subset so a still-processing COG is never opened (opening a mid-write
// COG poisons the per-project handle cache until the server reloads).
samplingLayers = DEFAULT_PROFILE_SAMPLING_LAYERS) => {
    const startCartographic = Cesium.Cartographic.fromCartesian(startPos);
    const endCartographic = Cesium.Cartographic.fromCartesian(endPos);
    const distance = Cesium.Cartesian3.distance(startPos, endPos);
    try {
        const profile = await elevationService.getLineElevationProfile(projectId, Cesium.Math.toDegrees(startCartographic.latitude), Cesium.Math.toDegrees(startCartographic.longitude), Cesium.Math.toDegrees(endCartographic.latitude), Cesium.Math.toDegrees(endCartographic.longitude), metersToSampleCount(distance), samplingLayers);
        return profile;
    }
    catch (err) {
        console.error('Failed to fetch line elevation profile:', err);
        return null;
    }
};
